export default __webpack_public_path__ + "static/media/hepsiTruck.774e8cd0.svg";